"use client";
import React from "react";
import Block from "./webflow_modules/Basic/components/Block";
import Link from "./webflow_modules/Basic/components/Link";

export function RedoSearchButton({
  buttonProps = {},
  showShowDisabled = true,
  showShowEnabled = true,
}) {
  return (
    <Block className={"redo-search-component"} tag={"div"}>
      {showShowDisabled ? (
        <Link
          button={true}
          className={"redo-search disabled"}
          options={{
            href: "#",
          }}
          {...buttonProps}
        >
          {"Redo Search"}
        </Link>
      ) : null}
      {showShowEnabled ? (
        <Link
          button={true}
          className={"redo-search"}
          options={{
            href: "#",
          }}
          {...buttonProps}
        >
          {"Redo Search"}
        </Link>
      ) : null}
    </Block>
  );
}
